import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SmartHomeComponent } from '@vi-iot/client';
import { SmartHomeComponentsActions } from './smart-home-components.actions';
import { SmartHomeComponentsSelectors } from './smart-home-components.selectors';

@Injectable({ providedIn: 'root' })
export class SmartHomeComponentsStore {
  state$ = this.store.select(SmartHomeComponentsSelectors.getState());
  smartHomeComponents$ = this.store.select(SmartHomeComponentsSelectors.getSmartHomeComponents());
  isAllowedToSeeSmartHomeComponents$ = this.store.select(
    SmartHomeComponentsSelectors.isAllowedToSeeSmartHomeComponents
  );

  constructor(private store: Store) {}

  getSmartHomeComponents(installationId: number): void {
    this.store.dispatch(SmartHomeComponentsActions.getSmartHomeComponents({ installationId }));
  }

  updateSmartHomeComponents(
    installationId: number,
    smartHomeComponents: SmartHomeComponent[]
  ): void {
    this.store.dispatch(
      SmartHomeComponentsActions.updateSmartHomeComponents({ installationId, smartHomeComponents })
    );
  }
}
